import { Spinner, Stack, colors } from '@my/ui'
import { Heart } from '@tamagui/lucide-icons'

export interface SaveOfferButtonProps {
  offerId: string
  loading: boolean
  saved: boolean
  size?: number
  color?: string
  onPress: () => void
}

export const SaveOfferButton = (props: SaveOfferButtonProps) => {
  const isSaved = !props.loading && props.saved
  const color = props.color || colors.white
  const fill = isSaved ? color : 'rgba(0,0,0,0)'

  return (
    <Stack tag="button" onPress={props.onPress} cursor="pointer" aria-label="Save offer">
      {!props.loading && (
        <Heart size={props.size || 36} strokeWidth={2} color={color} fill={fill} />
      )}
      {props.loading && (
        <Stack jc="center" ai="center" width={props.size || 36} height={props.size || 36}>
          <Spinner size="small" color={color} />
        </Stack>
      )}
    </Stack>
  )
}
